import { CountryLocalizedEntity, CityLocalizedEntity } from 'src/store';

export interface FileEntity {
  id: string;
  url: string;
  name: string;
  ext: string;
  mime: string;
  size: number;
  caption?: string;
  alternativeText?: string;
  width?: number;
  height?: number;
  formats?: any;
  hash?: string;
}

export interface AssetCategoryEntity {
  id: string;
  name_en: string;
  name_de: string;
  key: AssetCategoryEnum;
}

export interface AssetEntity {
  id: string;
  name?: string;
  type: AssetType;
  asset_category: AssetCategoryEntity;
  subtype: AssetSubtype;
  file: FileEntity;
  format_3x2?: FileEntity;
  format_16x9?: FileEntity;
  country?: CountryLocalizedEntity;
  city?: CityLocalizedEntity;
  creator?: string;
  // Formats available: thumbnail, large, medium, small
  formats?: Record<string, AssetFormat>;
  channels?: string[];
  sorting?: number;
}

export interface AssetFormat {
  name: string;
  hash: string;
  ext: string;
  mime: string;
  width: number;
  height: number;
  size: number;
  path: number;
  url: string;
}
export enum AssetType {
  Image = 'image',
  CAD = '3d-file',
  PDF = 'pdf',
}

export type AssetSubtype = AssetImageSubtype | AssetCADSubtype | AssetPDFSubtype;

export enum AssetImageSubtype {
  Clipped = 'picture.clipped.',
  Cutout = 'picture.pdp-cutout.',
  Preview = 'picture.preview.',
  PersonPortrait = 'picture.personPortrait.',
  Reference = 'picture.reference.',
  Ambiance = 'picture.ambiance.',
  Drawing = 'picture.drawing.',
}

export enum AssetPDFSubtype {
  ProductSheet = 'root.productsheet.',
  PressRelease = 'root.pressrelease.',
  Instructions = 'root.manual.gebrauchsanleitung.',
  Maintenance = 'root.pflege.',
  Zerti = 'root.zerti.',
  SpaceType = 'interior-space-typ',
  Certificate = 'picture.certificate.',
  FabricMaterial = 'root.material.fabric.',
  LeatherMaterial = 'root.material.leder.',
  SurfaceMaterial = 'root.material.surface.',
  SurfaceEMaterial = 'root.material.surfacee.',
  SurfaceOMaterial = 'root.material.surfaceo.',
}

export enum AssetCADSubtype {
  DXF = 'dxf',
  DS3 = '3ds',
  DWG = 'dwg',
  SKP = 'skp',
}

export enum AssetCategoryEnum {
  Leather = 'leathers',
  Fabric = 'fabrics',
  Surface = 'surfaces',
  Care = 'care',
  Instructions = 'instructions',
  Certificates = 'certificates',
  Magazines = 'magazines',
  Brochures = 'brochures',
  Press = 'press',
}
